import { BASE_URL } from "./ServerEndpointController";
import axios from "axios";

const SAMPLES_STATS_ENDPOINT = `${BASE_URL}/samples/stats`;
const USERS_STATS_ENDPOINT = `${BASE_URL}/users/stats`;

export async function getUsersCount(queryParams) {
    try {
        const endpoint = queryParams ? `${USERS_STATS_ENDPOINT}/count?${queryParams}` : `${USERS_STATS_ENDPOINT}/count`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching users count:", error);
    }
}

export async function getMacroWeights(queryParams) {
    try {
        const endpoint = queryParams ? `${SAMPLES_STATS_ENDPOINT}/macro/weights/?${queryParams}` : `${SAMPLES_STATS_ENDPOINT}/macro/weights`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching macro weights:", error);
    }
}

export async function getSampleCounts(queryParams) {
    try {
        const endpoint = queryParams ? `${SAMPLES_STATS_ENDPOINT}/count?${queryParams}` : `${SAMPLES_STATS_ENDPOINT}/count`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching sample counts:", error);
    }
}

export async function getPopularItems(queryParams) {
    try {
        const endpoint = queryParams ? `${SAMPLES_STATS_ENDPOINT}/popular?${queryParams}` : `${SAMPLES_STATS_ENDPOINT}/popular`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching popular items:", error);
    }
}

export async function getPiechartDistribution(queryParams) {
    try {
        const endpoint = queryParams ? `${SAMPLES_STATS_ENDPOINT}/distribution/piechart?${queryParams}` : `${SAMPLES_STATS_ENDPOINT}/distribution/piechart`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching pie chart distribution:", error);
    }
}
